import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Typography } from 'ui-components-web'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { startOfMonth } from 'date-fns/startOfMonth'
import { endOfMonth } from 'date-fns/endOfMonth'
import { startOfWeek } from 'date-fns/startOfWeek'
import { eachDayOfInterval } from 'date-fns/eachDayOfInterval'

import { getWeekDays } from 'util/formatters'
import useStyles from './styles'

const Calendar = ({ renderCell, date = Date.now(), classes }) => {
  const initialClasses = useStyles()

  const cells = useMemo(
    () =>
      eachDayOfInterval({
        start: startOfWeek(startOfMonth(date)),
        end: endOfMonth(date),
      }),
    [date],
  )

  const weekDays = useMemo(() => getWeekDays(), [])

  return (
    <>
      <div className={initialClasses.grid7}>
        {weekDays.map((d) => (
          <Typography key={d} variant={'body2'} className={initialClasses.weekDay}>
            {d}
          </Typography>
        ))}
      </div>
      <div className={classNames(initialClasses.grid7, initialClasses.cells, classes?.cells)}>
        {cells.map(renderCell)}
      </div>
    </>
  )
}

Calendar.propTypes = {
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  renderCell: PropTypes.func.isRequired,
  classes: PropTypes.object,
}

export default Calendar
